export default "-- RTABench Q14\nSELECT\n  sum(stock*price),\n  category\nFROM\n    products\nWHERE\n    category = 'Electronics'\nGROUP BY\n    category;";